<template>
   <div class="page-header-container">
      <PageFrameContainer>
         <h1>{{title}}</h1>
         <p>{{desc}}</p>
         <slot/>
      </PageFrameContainer>
   </div>

</template>

<script>
    import PageFrameContainer from "./PageFrameContainer";
    export default {
        name: "PageHeader",
        components: {PageFrameContainer},
        props:["title","desc"]
    }
</script>

<style scoped lang="scss">
   @import "../theme/theme";

   .page-header-container {
      padding-top: 1.5rem;
      padding-bottom: 1.5rem;
      background: $primary100;
      margin-bottom: 2rem;

      h1 {
         color: $primaryText100;
         margin-block-start: 0;
         margin-block-end: 0;
         font-size: 2.3rem;
         font-weight: 300;
         margin: 0;
      }

      p {
         color: $primaryText100;
         font-size: 1.6rem;
         font-weight: 300;
         margin: 1rem 0;
      }

      color: $primaryText100;
   }

</style>